import { DashboardRow } from "@/lib/types";
import { formatNumber, percent } from "@/lib/utils";

type SummaryTableProps = {
  rows: DashboardRow[];
};

export default function SummaryTable({ rows }: SummaryTableProps) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-slate-900">Detailed Summary</h2>
        <p className="text-sm text-slate-500">
          Term-by-term and group-by-group metrics.
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full border-separate border-spacing-0 text-sm">
          <thead>
            <tr className="bg-slate-50 text-left text-slate-600">
              <th className="px-4 py-3">Term</th>
              <th className="px-4 py-3">Student Type</th>
              <th className="px-4 py-3">Applications</th>
              <th className="px-4 py-3">Beds</th>
              <th className="px-4 py-3">Accepted</th>
              <th className="px-4 py-3">Occupied</th>
              <th className="px-4 py-3">Waitlist</th>
              <th className="px-4 py-3">Shortage</th>
              <th className="px-4 py-3">Acceptance Rate</th>
              <th className="px-4 py-3">Occupancy Rate</th>
              <th className="px-4 py-3">Waitlist Rate</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.housing_record_id} className="border-t border-slate-100 text-slate-700">
                <td className="px-4 py-3">{row.term_name}</td>
                <td className="px-4 py-3">{row.student_type_name}</td>
                <td className="px-4 py-3">{formatNumber(row.applications)}</td>
                <td className="px-4 py-3">{formatNumber(row.available_beds)}</td>
                <td className="px-4 py-3">{formatNumber(row.accepted_offers)}</td>
                <td className="px-4 py-3">{formatNumber(row.occupied_beds)}</td>
                <td className="px-4 py-3">{formatNumber(row.waitlist_count)}</td>
                <td className="px-4 py-3">{formatNumber(row.shortage)}</td>
                <td className="px-4 py-3">{percent(row.acceptance_rate)}</td>
                <td className="px-4 py-3">{percent(row.occupancy_rate)}</td>
                <td className="px-4 py-3">{percent(row.waitlist_rate)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
